.surface {
  position: fixed;
  z-index: 50;
  background: var(--c-surface-elevated);
  border: 1px solid var(--c-border-strong);
  border-radius: 10px;
  box-shadow: var(--shadow-pop);
  padding: 6px;
  max-height: min(420px, calc(100vh - 80px));
  overflow: auto;
}

.hint {
  padding: 12px 14px;
  font-size: var(--text-caption);
  line-height: 1.5;
  color: var(--c-text-secondary);
}

.hintTrigger {
  display: inline-flex;
  border: 0;
  padding: 0;
  background: none;
  color: var(--c-text-tertiary);
}

.hintTrigger:hover {
  color: var(--c-text-primary);
}

.menuItem {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  height: 34px;
  padding: 0 10px;
  border: 0;
  border-radius: var(--radius-sm);
  background: none;
  text-align: left;
  font-size: var(--text-caption);
  color: var(--c-text-primary);
}

.menuItem:hover:not(:disabled),
.menuItem:focus-visible {
  background: var(--c-overlay);
  outline: none;
}

.menuItem:disabled {
  color: var(--c-text-disabled);
}

.menuItem.danger {
  color: var(--c-negative);
}

.menuItem .check {
  margin-left: auto;
  color: var(--c-brand-muted);
}

.menuDivider {
  height: 1px;
  margin: 4px 0;
  background: var(--c-border);
}

.menuLabel {
  padding: 6px 10px 4px;
  font-size: var(--text-micro);
  font-weight: 600;
  letter-spacing: 0.8px;
  text-transform: uppercase;
  color: var(--c-text-tertiary);
}
